import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FilterMatchMode } from 'primeng/api';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.css']
})
export class DropdownFilterComponent implements OnInit {
  @Input() field: any;
  @Input() table: any;
  @Input() filters: any;
  filterFormGroup: FormGroup;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();
  @Input() values = [];
  @Input() optionLabel: any;
  @Input() optionValue: any;
  matchModeOptions = [
    { label: "Equals", value: "custom-equals" },
    { label: "Not Equals", value: "not-equals" },
  ];
  constructor(private _fb: FormBuilder) { }

  ngOnInit(): void {
    this.initialSetup();
  }

  initialSetup() {
    this.filterFormGroup = this._fb.group({
      matchModeControl: new FormControl('custom-equals'),
      valueControl: new FormControl(null)
    })
  }

  apply(formGroup, fieldName) {
    let value = formGroup.value;
    this.table.filters[fieldName][0].value = value.valueControl;
    this.table.filters[fieldName][0].matchMode = value.matchModeControl;
    this.table.filters[fieldName][0].operator = 'and';
    this.filters = this.table.filters;
    this.applyFilter.emit();
  }

  clear(fieldName) {
    for (let i = 0; i < this.table.filters[fieldName].length; i++) {
      this.table.filters[fieldName][i].value = null;
      this.table.filters[fieldName][i].matchMode = "custom-equals";
      this.table.filters[fieldName][i].operator = null;
    }
    this.filters = this.table.filters;
    this.applyFilter.emit();
  }

  filterOpen(form: FormGroup, fieldName, control1, control2) {
    if (this.table.filters[fieldName] != undefined) {
      for (let i = 0; i < this.table.filters[fieldName].length; i++) {
        form.controls[control1].setValue(this.table.filters[fieldName][i].matchMode);
        if(this.table.filters[fieldName][i].value != null && this.table.filters[fieldName][i].value != undefined){
          form.controls[control2].setValue(this.table.filters[fieldName][i].value);
        }else{
          form.controls[control2].setValue(this.values[0][this.optionValue]);
        }
      }
    }
  }
}

